export default __webpack_public_path__ + "static/media/Nicolas_Mejia.2bf4fa74.png";